import { render, staticRenderFns } from "./ButtonsOfSendEmail.vue?vue&type=template&id=5c92abb5&"
import script from "./ButtonsOfSendEmail.vue?vue&type=script&lang=ts&"
export * from "./ButtonsOfSendEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports